// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_EntryReportResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/entry_report/{order_item_id}.
 *
 * Returns the entry report composite row, or null when neither the report
 * nor the order item exist.
 */
import type { Orders_EntryReportRow } from './Orders_EntryReportRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_EntryReportResponseDados = Orders_EntryReportRow;

export type Orders_EntryReportResponse = ApiResponse<Orders_EntryReportResponseDados>;

registerResponseContract('Orders_EntryReportResponse', {
  _nullable:                     { type: 'boolean', required: false },
  so_entry_report_id:            { type: 'number',  required: false },
  so_entry_report_order_item_id: { type: 'number',  required: false },
  so_entry_report_confirmed:     { type: 'number',  required: false },
  so_entry_report_confirmed_at:  { type: 'string',  required: false },
  so_entry_report_confirmed_by:  { type: 'string',  required: false },
  so_entry_report_created_at:    { type: 'string',  required: false },
  so_order_item_id:              { type: 'number',  required: false },
  so_order_item_service_id:      { type: 'number',  required: false },
  so_order_item_type:            { type: 'string',  required: false },
  so_order_item_description:     { type: 'string',  required: false },
  so_order_item_qrcode:          { type: 'string',  required: false },
  description:                   { type: 'string',  required: false },
  qr_code:                       { type: 'string',  required: false },
  client_name:                   { type: 'string',  required: false },
  status:                        { type: 'string',  required: false },
  attributes: {
    type: 'array',
    required: false,
    items: {
      attribute_id:  { type: 'number',  required: true },
      name:          { type: 'string',  required: true },
      type:          { type: 'string',  required: true },
      required:      { type: 'boolean', required: true },
      display_order: { type: 'number',  required: true },
      value:         { type: 'string',  required: false },
      options: {
        type: 'array',
        required: false,
        items: {
          value: { type: 'string',  required: true },
          label: { type: 'string',  required: true },
        },
      },
    },
  },
  so_entry_report_checklist:     { type: 'string',  required: false },
  cliente_nome:                  { type: 'string',  required: false },
})
